// extracted by mini-css-extract-plugin
module.exports = {"sections":"Sections__sections___2HSYL","heading":"Sections__heading___3EWgj"};